//*general
import logo from "./general/Logo.svg";
//*icon
import back from "./icon/Back.svg";
import iconlist from "./icon/icondyna.svg";
//* Helpes
import handhelp from "./models/helpview/ar_hand_prompt.png";
import iconhelp from "./models/helpview/ar.svg";
import iconhelpwhite from "./models/helpview/arwhite.svg";
//* Models
import balata from "./models/balata/Balata.glb";
import balataposter from "./models/balata/poster.webp";
import disco from "./models/disco/Disco_GLB.glb";
import discoposter from "./models/disco/poster.webp";
import disco2 from "./models/disco2/Disco_GLB.glb";
import disco2poster from "./models/disco2/poster.webp";
import balatapeque from "./models/balatapequeña/Balatapequenia_GLB.glb";
import balatapequeposter from "./models/balatapequeña/poster.webp";
//* hdr
import hdrModels from "./models/hdrmodels.hdr";

import cardIfografia from "./cardIfografia.svg";

export const typeAssets = {
	general: {
		logo,
	},
	icon: {
		back,
		iconlist,
	},
	cardIfografia,
};

export const typeHelpModelViewer = {
	handhelp,
	iconhelp,
	iconhelpwhite,
};

export const typeModelsProject = {
	hrd: hdrModels,
	balataPeque: {
		model: balatapeque,
		poster: balatapequeposter,
	},
	disco: {
		model: disco,
		poster: discoposter,
	},
	disco2: {
		model: disco2,
		poster: disco2poster,
	},
	balataModel: {
		model: balata,
		poster: balataposter,
	},
};
